import { type QueryKey } from '@tanstack/react-query';
import { type ReactElement } from 'react';
import { ExecutionRunsTableV2 } from '@/features/executionRuns/components/ExecutionRunsTableV2';
import { getEmptyStateMessage } from '@/shared/copy/emptyStates';
import type { TableQueryMeta } from '@/features/shared/components/tableSystem/tableToolbar.helpers';
import type { TagOption } from '@/shared/data/tags';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { ExecutionRunDto, QueryResult } from '@flowqa/shared';

type ExecutionRunsTableV2PanelProps = {
  active: boolean;
  fixedFilters?: GridQueryInput['filters'];
  forceLoading?: boolean;
  onQueryMeta?: (meta: TableQueryMeta<ExecutionRunDto> | null) => void;
  queryFn: (input: GridQueryInput) => Promise<QueryResult<ExecutionRunDto>>;
  queryKey: QueryKey;
  search: string;
  tagOptions: TagOption[];
};

export const ExecutionRunsTableV2Panel = ({
  active,
  fixedFilters,
  forceLoading = false,
  onQueryMeta,
  queryFn,
  queryKey,
  search,
  tagOptions,
}: ExecutionRunsTableV2PanelProps): ReactElement | null => {
  if (!active) {
    return null;
  }

  return (
    <ExecutionRunsTableV2
      fixedFilters={fixedFilters}
      forceLoading={forceLoading}
      search={search}
      tagOptionsOverride={tagOptions}
      queryKey={queryKey}
      queryFn={queryFn}
      initialPageSize={10}
      active={active}
      noRowsText={getEmptyStateMessage('entity.noneFound', { entity: 'executionRun' })}
      onQueryMeta={onQueryMeta}
    />
  );
};
